var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 6,
    viewBox: "0 0 120 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M118.713 0C117.869 0 117.306 0.2 117.306 0.5C117.306 1.85 116.04 2.8 113.508 3.55C102.959 6.6 71.3119 4.2 45.9941 2.25C21.9421 0.4 7.03274 -0.6 1.82851 0.85C0.562619 1.2 0 1.7 0 2.25C0 2.55 0.562619 2.75 1.40655 2.75C2.25048 2.75 2.81309 2.55 2.81309 2.25C2.81309 2 3.0944 1.8 3.65702 1.65C8.01732 0.4 27.0057 1.85 45.4315 3.25C62.8726 4.55 81.7204 6 96.0672 6C104.225 6 110.977 5.55 115.196 4.3C118.431 3.4 119.978 2.1 119.978 0.5C120.119 0.2 119.556 0 118.713 0Z",
    fill: "url(#paint0_linear_93_7)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_93_7",
    x1: 0,
    y1: 3,
    x2: 120,
    y2: 3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F264DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.335,
    stopColor: "#DA61FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.645,
    stopColor: "#AA7CFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8C8EFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup1);
export default __webpack_public_path__ + "static/media/Group (1).ae7300a1948c4302750316a69bd309ab.svg";
export { ForwardRef as ReactComponent };